module.exports = __webpack_public_path__ + "static/media/cor1.75e52671.png";